export const exportActionTargetId = 'leads-export-action'
export const EXPORT_ACTION_TARGET = `#${exportActionTargetId}`
